/**
 * Keycloak configuration for the Flow Designer application
 * These values should be overridden via environment variables in production
 */

export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

export const getKeycloakConfig = (): KeycloakConfig => {
  return {
    url: (import.meta as any).env.VITE_KEYCLOAK_URL || 'http://localhost:8080',
    realm: (import.meta as any).env.VITE_KEYCLOAK_REALM || 'enveu',
    clientId: (import.meta as any).env.VITE_KEYCLOAK_CLIENT_ID || 'flow-designer',
  };
};
